<script>
  /* eslint-disable new-cap */
import Layout from '@layouts/primary'
import { collectionMethods, clientMethods, serviceMethods, runsheetMethods, instanceExceptionMethods } from '@state/helpers'
import store from '@state/store'
import ListLoading from '../../components/loading'
export default {
  $_veeValidate: {
    validator: 'new',
  },
  page: {
    title: 'IncompleteCollections',
    meta: [{ name: 'description', content: 'IncompleteCollections' }],
  },
  components: { Layout,ListLoading },
  data() {
    return {
      instanceException: [],
      search: '',
      headers: [
        { text: 'Collection Date', value: 'dateSeconds' },
        // { text: 'Access Time', value: 'expected_collection_time' },
        { text: 'Client Name', value: 'client.client_name' },
        { text: 'Address', value: 'site.address' },
        { text: 'Suburb', value: 'site.suburb' },
        { text: 'Postcode', value: 'site.postcode' },
        { text: 'Note/Photo', value: 'name', sortable: false ,width:"5%"},
        { text: ' Collection Actions', value: 'actions', sortable: false },
      ],
      collectionsList: [],
      clients:[],
      clientsData:[],
      services:[],
      currentService:[],
      runSheets:[],
      newCollection: {
        client: null,
        driver_id: null,
        service_id: null,
        service_title: null,
        expected_collection_time: null,
        created_by: null,
        collection_date: null,
        collection_time: null,
        order: null,
        lat: null,
        lon: null,
        completed: false, // Default value
        processed: false, // Default value
        runSheetId: null,
        site: {},
      },
      chargeClient:{
        amount: "",
        reason: "",
      },
      currentCollection:[],
      dateCollectionDialog: false,
      dictionary: {
        attributes: {
          // email: 'E-mail Address',
          // custom attributes
        },
        custom: {
          name: {
            required: () => 'Name can not be empty',
            max: 'The name field may not be greater than 10 characters',
            // custom messages
          },
          select: {
            required: 'Select field is required',
          },
        }
      },
      collection:"",
      loadingData: true,
      addCollection: false,
      chargeCollection: false,
      cancelCollection: false,
      currentCollectionId: "",
      currentIncompleteCollectionId: "",
    }
  },
  mounted() {
    this.$validator.localize('en', this.dictionary)
    // status default for cant perform collections = 1
    this.getInstanceExceptionsByStatus({status: 1}).then(response => {
      let obj = this.$store.state.instanceExceptions.objects
      let moment = require('moment');
      for (let v in obj) {

        if(obj[v].description)
          this.currentCollection.push(obj[v])

        // Create a copy of the object to update it
        let formattedObj = {
          ...obj[v].collection
        }
        // Store exception Id
        formattedObj.exceptionId = obj[v].id
        // Convert to Hours
        let serviceTime = obj[v].collection.expected_collection_time
        let hours = new moment(serviceTime * 1000);
        formattedObj.expected_collection_time = hours.format('H:mm A')

        // Convert Date
        formattedObj.collection_date = moment(obj[v].collection.collection_date).format('DD/MM/YYYY')
        formattedObj.dateSeconds = moment(obj[v].collection.collection_date).valueOf()
        if(formattedObj && formattedObj.client)
          this.collectionsList.push(formattedObj)
      }
    })

    // console.log(this.currentCollection)
    this.getClients().then(response => {
      let obj = this.$store.state.clients.objects
      for (let v in obj) {
        this.clients.push(obj[v])
      }
      this.clientsData = this.clients.map(index => { return { client_id: index.id, client_name: index.client_name } })
    })
    this.loadingData=false
  },
  methods: {
    ...collectionMethods, ...clientMethods, ...serviceMethods, ...runsheetMethods, ...instanceExceptionMethods,
    submit() {
      this.$validator.validateAll()
      this.createNewCollection()
    },
    async cancel(incExceptionId, colId){
      // Cancel status for exception = 2
      let cancelStatus = 2;
      await this.updateCollectionInstanceException({exceptionId: parseInt(incExceptionId), status: cancelStatus, collectionId: parseInt(colId)})
        .then((result) => {
          if(result){
            location.reload()
          }
        })
    },
    async getCollectionException(id){
      // // console.log(id)
      await this.getInstanceExceptionById({exceptionId: id}).then(response => {
        // // console.log(response)
        this.instanceException = response;
      })
    },
    cancelCurrentCollection(incExceptionId, colId){
      this.currentCollectionId = colId;
      this.currentIncompleteCollectionId = incExceptionId;
      this.cancelCollection = !this.cancelCollection;
    },
    async createNewCollection(){
      await this.$validator.validateAll().then((response) => {
        // console.log(response)
        if(response){
          let userId = store.getters['auth/getUserId'];
          let serviceId = this.newCollection.service_id
          let expectedCollectionTime = this.newCollection.expected_collection_time
          let createdBy = userId
          let collectionDate = this.newCollection.collection_date
          let collectionTime = this.newCollection.expected_collection_time
          let order = this.newCollection.order
          let completed = this.newCollection.completed
          let processed = this.newCollection.processed
          let runsheetId = this.newCollection.runSheetId

          this.createCollection({
            service_id: parseInt(serviceId),
            expected_collection_time: expectedCollectionTime,
            created_by: createdBy,
            collection_date: collectionDate,
            collection_time: collectionTime,
            order: order,
            completed: completed,
            processed: processed,
            runsheetId: runsheetId
          })
            .then(d => {
              // Update status to 3 (Re-booked)
              let incExceptionId = this.newCollection.exceptionId
              let colId = this.newCollection.id
              let status = 3;
              this.updateCollectionInstanceException({exceptionId: parseInt(incExceptionId), status: status, collectionId: parseInt(colId)})
                .then((result) => {
                  if(result){
                    location.reload()
                  }
                })
            })
        }
      })
    },
    addNewCollection(collectionData){
      this.addCollection = !this.addCollection
      this.newCollection = collectionData
    },
    chargeCollectionTapped(reason){
      this.chargeClient = reason
      for(let i in this.currentCollection)
      {
        if(reason.exceptionId === this.currentCollection[i].id)
        {
          console.log(this.currentCollection[i])
          this.chargeClient.reason = this.currentCollection[i].description
          if (this.currentCollection[i].collection.cost > 0) {
            this.chargeClient.amount = (this.currentCollection[i].collection.cost / 2) / 100
          }
        }
      }
      this.chargeCollection = !this.chargeCollection
    },
    performChargeClient(){
      let colId = parseInt(this.chargeClient.id)
      let _reason = this.chargeClient.reason
      let _amount = this.chargeClient.amount

      if(_amount > 0){
        _amount = this.chargeClient.amount * 100 // IT NEEDS TO BE CENTS
      }

      this.updateCollectionCharge({
        collectionId: colId,
        reason: _reason,
        amount: _amount
      }).then(d => {
        // console.log(this.chargeClient.exceptionId)
        this.updateCollectionInstanceException({exceptionId: parseInt(this.chargeClient.exceptionId), status: -1})
          .then((res) => {
            // console.log(res)
            if(res){
              location.reload()
            }
          })
      })

    },
    clear() {
      this.newCollection = {}
      this.$validator.reset()
      this.addCollection = false
      this.chargeCollection = false
    },
    changeRoute(r) {
      this.$router.push(r)
    },
    getClientID(client){
      let cid = null
      for(let i in this.clientsData){
        if(client === this.clientsData[i].client_name){
          cid = this.clientsData[i].client_id;
        }
      }
      return cid;
    },
    async getRunSheets(date){
      await this.getRunsheetsByDate({date: date}).then(response => {
        this.runSheets = response;
      })
    },
    async onClientChange(client){
      // Clean current data before populate again
      this.services = []
      this.currentService = []
      this.newCollection.site = {}
      let cid = this.getClientID(client)

      await this.getServiceByClientId({id: cid}).then(response => {
        this.services = response
      })
    },
    setCurrentService(service){
      for(let i in this.services){
        if(service === this.services[i].service_title){
          this.currentService = this.services[i].site;
          this.newCollection.site = this.currentService;
          this.newCollection.service_id = this.services[i].id
          this.newCollection.service_title = this.services[i].service_title
        }
      }
    },
    onServiceChange(service){
      this.setCurrentService(service)
    },
    onDateChange(date){
      this.dateCollectionDialog = false;
      this.getRunSheets(date);
    },
    onRunSheetSelected(id){
      // Determine the collection order
      for(let i in this.runSheets){
        if (this.runSheets[i].id === id){
          // Get last collection position
          if(this.runSheets[i].collections.length > 0 ){
            this.newCollection.order = this.runSheets[i].collections.length;
          } else {
            // Otherwise will be first collection order
            this.newCollection.order = 1;
          }
        }
      }
    }
  },
}
</script>

<template>
  <Layout>
    <VContainer>
      <div class="">
        <h2 :class="$style.routeHeader">
          Incomplete Collections
        </h2>
      </div>
      <ListLoading :display="loadingData" />
      <VLayout
        v-if="!loadingData"
        style="width: 100%"
      >

        <VFlex
          xs0
          sm12
        />
        <VFlex
          xs12
          md5
        >
          <VTextField
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          />
        </VFlex>
      </VLayout>

      <div v-if="collectionsList">
        <VDataTable
          v-if="!loadingData"
          :headers="headers"
          :items="collectionsList"
          :search="search"
          rows-per-page-text=""
          :rows-per-page-items="[10]"
        >
          <template
            slot="items"
            slot-scope="props"
          >
            <td class="text-xs-left">
              {{ props.item.collection_date }}
            </td>
            <!--<td class="text-xs-left">-->
            <!--{{ props.item.expected_collection_time }}-->
            <!--</td>-->
            <td class="text-xs-left">
              {{ props.item.client.client_name }}
            </td>
            <td class="text-xs-left">
              {{ props.item.site.address }}
            </td>
            <td class="text-xs-left">
              {{ props.item.site.suburb }}
            </td>
            <td class="text-xs-left">
              {{ props.item.site.postcode }}
            </td>

            <td class="justify-center px-0">
              <VBtn
                slot="activator"
                style="display: block; position:relative; margin: 0 auto"
                color="blue"
                @click.native="changeRoute({name: 'view-collection-notes-photos', params: {id: props.item.id}})"
              >
                View
              </VBtn>
            </td>
            <td
              style="
              display: flex;
              flex-direction: row;
              justify-items: center;
              align-content: center;
              align-items: center;
            "
            >
              <VBtn
                slot="activator"
                style="display: block; position:relative; margin: 0 auto; margin-right: 10px"
                color="orange"
                @click.native="cancelCurrentCollection(props.item.exceptionId, props.item.id)"
              >
                Cancel
              </VBtn>
              <VBtn
                slot="activator"
                style="display: block; position:relative; margin: 0 10px 0 0;"
                color="yellow"
                @click.native="chargeCollectionTapped(props.item)"
              >
                Charge
              </VBtn>
              <VBtn
                slot="activator"
                style="display: block; position:relative; margin: 0 auto"
                color="green"
                @click.native="addNewCollection(props.item)"
              >
                Re-book
              </VBtn>
            </td>
          </template>
        </VDataTable>
      </div>

      <!-- COLLECTION MODAL -->
      <div v-if="chargeClient">
        <VLayout
          row
          justify-center
        >
          <VDialog
            v-model="chargeCollection"
            persistent
            max-width="500px"
            scrollable
          >
            <VCard>
              <VCardText>
                <VContainer grid-list-md>
                  <h2>Charge Collection</h2>
                  <VLayout wrap>

                    <VFlex xs12>
                      <VTextField
                        v-model="chargeClient.amount"
                        label="Charge Amount"
                        required
                        prefix="$"
                        type="number"
                        hint="Default amount is half of the collection cost"
                        persistent-hint
                      />
                    </VFlex>

                    <VFlex xs12>
                      <VTextField
                        v-model="chargeClient.reason"
                        label="Charge Reason"
                        required
                      />
                    </VFlex>

                    <VFlex
                      xs12
                      sm6
                      md6
                    >
                      <VBtn
                        color="blue"
                        block
                        outline
                        @click.native="chargeCollection = false"
                      >
                        Close
                      </VBtn>
                    </VFlex>
                    <VFlex
                      xs12
                      sm6
                      md6
                    >
                      <VBtn
                        color="blue"
                        block
                        @click.native="performChargeClient()"
                      >
                        Charge
                      </VBtn>
                    </VFlex>
                  </VLayout>
                </VContainer>
              </VCardText>
            </VCard>
          </VDialog>
        </VLayout>
      </div>


      <div v-if="newCollection">
        <VLayout
          row
          justify-center
        >
          <VDialog
            v-model="addCollection"
            persistent
            max-width="500px"
            scrollable
          >
            <VCard>
              <VCardText>
                <VContainer grid-list-md>
                  <h2>Re-book Collection</h2>
                  <VLayout wrap>

                    <VLayout wrap>
                      <VFlex xs12>
                        <VTextField
                          v-model="newCollection.site.address"
                          label="Address"
                          required
                          readonly
                        />
                      </VFlex>
                    </VLayout>

                    <VLayout wrap>
                      <VFlex xs6>
                        <VTextField
                          v-model="newCollection.site.postcode"
                          label="Post Code"
                          required
                          readonly
                        />
                      </VFlex>
                      <VFlex xs6>
                        <VTextField
                          v-model="newCollection.site.suburb"
                          label="Suburb"
                          required
                          readonly
                        />
                      </VFlex>
                    </VLayout>

                    <VLayout wrap>
                      <VFlex xs6>
                        <VTextField
                          v-model="newCollection.site.mobile"
                          label="Mobile"
                          required
                          readonly
                        />
                      </VFlex>
                      <VFlex xs6>
                        <VTextField
                          v-model="newCollection.site.phone"
                          label="Phone"
                          required
                          readonly
                        />
                      </VFlex>
                    </VLayout>

                    <VLayout wrap>
                      <VFlex xs6>
                        <VDialog
                          v-model="dateCollectionDialog"
                          persistent
                          width="290px"
                        >
                          <VTextField
                            slot="activator"
                            v-model="newCollection.collectionDate"
                            v-validate="'required'"
                            :error-messages="errors.collect('collection_date')"
                            data-vv-name="collection_date"
                            label="Date"
                            append-icon="event"
                            readonly
                          />
                          <VDatePicker
                            v-model="newCollection.collectionDate"
                            header-color="#00baff"
                            color="#00baff"
                            scrollable
                            @input="onDateChange(newCollection.collectionDate)"
                          />
                        </VDialog>
                      </VFlex>
                      <VFlex xs6>
                        <VTextField
                          v-model="newCollection.expected_collection_time"
                          label="Access Time"
                          required
                        />
                      </VFlex>
                    </VLayout>
                    <VFlex xs12>
                      <VSelect
                        v-model="newCollection.runSheetId"
                        v-validate="'required'"
                        :error-messages="errors.collect('runsheet')"
                        data-vv-name="runsheet"
                        :items="runSheets"
                        item-text="id"
                        label="Run Sheet"
                        required
                        :menu-props="{ absolute: true }"
                        attach
                        @input="onRunSheetSelected(newCollection.runSheetId)"
                      />
                    </VFlex>

                    <VFlex
                      xs12
                      sm6
                      md6
                    >
                      <VBtn
                        color="blue"
                        block
                        outline
                        @click.native="addCollection = false"
                      >
                        Close
                      </VBtn>
                    </VFlex>
                    <VFlex
                      xs12
                      sm6
                      md6
                    >
                      <VBtn
                        color="blue"
                        block
                        @click.native="createNewCollection()"
                      >
                        Re-Book
                      </VBtn>
                    </VFlex>
                  </VLayout>
                </VContainer>
              </VCardText>
            </VCard>
          </VDialog>
        </VLayout>
      </div>

      <VLayout
        row
        justify-center
      >
        <VDialog
          v-model="cancelCollection"
          persistent
          max-width="550px"
          scrollable
        >
          <VCard>
            <VCardText>
              <VContainer grid-list-md>
                <h2>Are you sure you want to cancel collection {{ currentIncompleteCollectionId }}?</h2>
                <br>
                <VLayout wrap>
                  <VFlex
                    xs12
                    sm6
                    md6
                  >
                    <VBtn
                      color="blue"
                      block
                      outline
                      @click.native="cancelCollection = !cancelCollection"
                    >
                      Close
                    </VBtn>
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                    md6
                  >
                    <VBtn
                      color="orange"
                      block
                      @click.native="cancel(currentIncompleteCollectionId, currentCollectionId)"
                    >
                      CANCEL
                    </VBtn>
                  </VFlex>
                </VLayout>
              </VContainer>
            </VCardText>
          </VCard>
        </VDialog>
      </VLayout>
    </VContainer>
  </Layout>
</template>

<style lang="scss" module>
  @import '@design';

  .routeHeader {
    display: inline-block;
  }

  .addButton {
    display: inline-block;
    float: right;
  }

  .rowTd {
  }
</style>
